import { render, staticRenderFns } from "./BlockField.vue?vue&type=template&id=33027186"
import script from "./BlockField.vue?vue&type=script&lang=js"
export * from "./BlockField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports